import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaBars, FaTimes, FaUser, FaSignOutAlt, FaClipboardList } from 'react-icons/fa';
import { logout } from '../../features/auth/authSlice';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const authLinks = (
    <>
      <Link 
        to="/dashboard" 
        className="block px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
        onClick={() => setIsOpen(false)}
      >
        Dashboard
      </Link>
      {user && user.isAdmin && (
        <Link 
          to="/admin/papers" 
          className="block px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
          onClick={() => setIsOpen(false)}
        >
          Manage Papers
        </Link>
      )}
      <button 
        onClick={handleLogout}
        className="flex items-center w-full text-left px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
      >
        <FaSignOutAlt className="mr-2" /> Logout
      </button>
    </>
  );

  const guestLinks = (
    <>
      <Link 
        to="/login" 
        className="block px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
        onClick={() => setIsOpen(false)}
      >
        Login
      </Link>
      <Link 
        to="/register" 
        className="block px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
        onClick={() => setIsOpen(false)}
      >
        Register
      </Link>
    </>
  );

  return (
    <header className="bg-white shadow-md">
      <nav className="container-wide py-4">
        <div className="flex flex-wrap justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <FaClipboardList className="text-primary-600 text-2xl mr-2" />
            <span className="text-xl font-semibold text-gray-800">Science Forum</span>
          </Link>

          {/* Mobile menu button */}
          <button 
            onClick={toggleMenu} 
            type="button" 
            className="inline-flex items-center p-2 ml-3 text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
          >
            <span className="sr-only">Open main menu</span>
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>

          {/* Main navigation */}
          <div className={`${isOpen ? 'block' : 'hidden'} w-full md:block md:w-auto`}>
            <ul className="flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:font-medium">
              <li>
                <Link 
                  to="/" 
                  className="block px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
                  onClick={() => setIsOpen(false)}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/papers" 
                  className="block px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
                  onClick={() => setIsOpen(false)}
                >
                  Papers
                </Link>
              </li>
              {isAuthenticated ? (
                <>
                  <li className="md:hidden">
                    <Link 
                      to="/dashboard" 
                      className="block px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
                      onClick={() => setIsOpen(false)}
                    >
                      Dashboard
                    </Link>
                  </li>
                  {user && user.isAdmin && (
                    <li className="md:hidden">
                      <Link 
                        to="/admin/papers" 
                        className="block px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
                        onClick={() => setIsOpen(false)}
                      >
                        Manage Papers
                      </Link>
                    </li>
                  )}
                  <li className="md:hidden">
                    <button 
                      onClick={handleLogout}
                      className="flex items-center w-full text-left px-4 py-2 hover:bg-gray-100"
                    >
                      <FaSignOutAlt className="mr-2" /> Logout
                    </button>
                  </li>
                </>
              ) : (
                <>
                  <li className="md:hidden">
                    <Link 
                      to="/login" 
                      className="block px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
                      onClick={() => setIsOpen(false)}
                    >
                      Login
                    </Link>
                  </li>
                  <li className="md:hidden">
                    <Link 
                      to="/register" 
                      className="block px-4 py-2 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0"
                      onClick={() => setIsOpen(false)}
                    >
                      Register
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>

          {/* User menu - desktop */}
          <div className="hidden md:flex items-center">
            {isAuthenticated ? (
              <div className="relative group">
                <button className="flex items-center space-x-2 focus:outline-none">
                  <FaUser className="text-gray-500" />
                  <span className="font-medium">{user && user.username}</span>
                </button>
                <div className="absolute right-0 w-48 py-2 mt-2 bg-white rounded-md shadow-xl z-20 hidden group-hover:block">
                  {authLinks}
                </div>
              </div>
            ) : (
              <div className="flex space-x-4">
                {guestLinks}
              </div>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar; 